export default __webpack_public_path__ + "static/media/banner.1684e0a3.png";